import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { makeKiddomPostRequest } from 'infrastructure/api'
import { useNotify } from 'shared/ui/Notify'

const ResyncDefaultChannelButton = ({
  classID,
  schoolID,
}: {
  classID?: number
  schoolID?: number
}) => {
  const [open, setOpen] = useState(false)
  const notify = useNotify()

  const triggerResync = async () => {
    let url = ''
    if (schoolID) {
      url = `/v1/kat/schools/${schoolID}/resync_channel_roster`
    } else if (classID) {
      url = `/v1/kat/classes/${classID}/resync_channel_roster`
    }
    try {
      const { error } = await makeKiddomPostRequest<
        undefined | { error?: unknown }
      >({ kiddomPath: url, requestBody: {} })
      if (error != null) {
        notify(error, { type: 'error' })
      }
    } catch {
      notify('Error occured during api call, contact rostering team', {
        type: 'error',
      })
    }
    setOpen(false)
  }
  const title = 'Are you sure you want to resync the default channel?'
  const buttonText = 'Resync Default Channel'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <Dialog onClose={handleClose} open={open} data-testid="dialog">
        <DialogTitle>{title}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={triggerResync}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ResyncDefaultChannelButton
